<template>
  <!--帖子列表页面-->
  <tk-container
    disable-scroll
    hide-status-bar
    :status="status"
  >
    <!--列表头部-->
    <grey-header slot="header" :title="$route.query.type === 'post' ? '我的发帖' : '获赞'"></grey-header>
    <!--列表详情-->
    <posts-container v-if="$route.query.type === 'post'" :posts-type="'post'" :profile-id="profileId"></posts-container>
    <posts-container v-else :posts-type="'myPraise'" :profile-id="profileId"></posts-container>
  </tk-container>
</template>

<script>
import postsContainer from '@/components/postsContainer'
export default {
  components: {
    postsContainer
  },
  data () {
    return {
      status: 'loading' // 页面状态
    }
  },
  computed: {
    // 个人主页用户Id
    profileId () {
      return this.$route.query.id
    }
  },
  activated () {
    this.setStatusBar('dark') // 离开还原内容为黑色
  },
  mounted () {
    this.getInit()
  },
  beforeRouteLeave (to, from, next) {
    next(true)
  },
  methods: {
    /**
    * 页面初始化
    * @date: 2020/4/13
    */
    async getInit () {
      try {
        this.status = false
      } catch (e) {
        this.status = 'error'
        this.$tkGlobal.toast.add('加载数据失败')
      }
    }
  }
}
</script>

<style scoped lang="scss">
</style>
